import { render, staticRenderFns } from "./LayoutComponent.vue?vue&type=template&id=65a1bcbc&scoped=true&"
import script from "./LayoutComponent.vue?vue&type=script&lang=js&"
export * from "./LayoutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a1bcbc",
  null
  
)

export default component.exports